// dialog-ref.ts
import { Subject } from 'rxjs';

export class DrawerRef<T = any> {
  private closeSubject = new Subject<T | undefined>();

  close(data?: T) {
    this.closeSubject.next(data);
    this.closeSubject.complete();
  }

  afterClosed() {
    return this.closeSubject.asObservable();
  }
}